// @ts-nocheck
// fetch prebook contractors
export const FETCH_PREBOOK_CONTRACTORS_REQUEST =
  "FETCH_PREBOOK_CONTRACTORS_REQUEST";
export const FETCH_PREBOOK_CONTRACTORS_SUCCESS =
  "FETCH_PREBOOK_CONTRACTORS_SUCCESS";
export const FETCH_PREBOOK_CONTRACTORS_FAILURE =
  "FETCH_PREBOOK_CONTRACTORS_FAILURE";

// prebook contractors
export const PREBOOK_CONTRACTORS_REQUEST = "PREBOOK_CONTRACTORS_REQUEST";
export const PREBOOK_CONTRACTORS_SUCCESS = "PREBOOK_CONTRACTORS_SUCCESS";
export const PREBOOK_CONTRACTORS_FAILURE = "PREBOOK_CONTRACTORS_FAILURE";

// check holddown dates
export const CHECK_FOR_HOLDDOWN_DATES_REQUEST =
  "CHECK_FOR_HOLDDOWN_DATES_REQUEST";
export const CHECK_FOR_HOLDDOWN_DATES_SUCCESS =
  "CHECK_FOR_HOLDDOWN_DATES_SUCCESS";
export const CHECK_FOR_HOLDDOWN_DATES_FAILURE =
  "CHECK_FOR_HOLDDOWN_DATES_FAILURE";